(function ($) {

  'use strict';

  let initFunctions = {
    initOnce: function () {
      initFunctions.init();
    },

    init: function (area) {
      let initArea = (area) ? area : $('body');
      
      /*   components   */
      /**************************/
      Common.init(initArea);
      //Datepicker.init(initArea);
      //Select2.init(initArea);
      SwiperSlider.init(initArea);
      MagnificPopup.init(initArea);
      //IncrementDecrement.init(initArea);
      //MainSearch.init(initArea);
      DestinationsPage.init(initArea);
      //Schedule.init(initArea);
      //Booking.init(initArea);
      
      //if (DeviceSelector.mobileAll()) {
      //  MobileOverlay.init(initArea);
      //}
    }
  };

  $(function () {
    initFunctions.initOnce();
  });

})(jQuery);
